import { STATUS_VARIANT_HIGHLIGHT } from '@/components/StatusWrapper/const';
import { StatusWrapper } from '@/components/StatusWrapper/StatusWrapper';
import { TaskStatusType } from '@/types/dashboardTypes';
import { ReactNode } from 'react';

const TASKS_STATUS_MAP = {
  completed: { variant: STATUS_VARIANT_HIGHLIGHT.GREEN },
  question: { variant: STATUS_VARIANT_HIGHLIGHT.RED },
  in_progress: { variant: STATUS_VARIANT_HIGHLIGHT.BLUE },
  closed: { variant: STATUS_VARIANT_HIGHLIGHT.GREY },
  assigned: { variant: STATUS_VARIANT_HIGHLIGHT.YELLOW },
};

type TasksStatusComponentType = {
  status: TaskStatusType;
  children: ReactNode;
};

export const TasksStatus = ({ status, children }: TasksStatusComponentType) => {
  return <StatusWrapper variant={TASKS_STATUS_MAP[status]?.variant}>{children}</StatusWrapper>;
};
